import React from "react";
import { Check, Textarea } from "../../";
import locales from "../../../constants";

const SubmitStep = ({
  register,
  errors,
  step,
  setStep,
  triggerValidation,
  formState,
  lang,
}) => {
  const translation = locales[lang];

  return (
    <div
      className="step_4 stepWrapper"
      style={{ display: step === 4 ? "block" : "none" }}
    >
      <h3 className="step-title">
        {translation.brief_campaign.step_4_main_header}
      </h3>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_campaign.step_4_business_goals_header}</h4>
          <p>{translation.brief_campaign.step_4_business_goals_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Textarea
            type="text"
            name="business_goals"
            label={translation.brief_campaign.step_4_business_goals_label}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_campaign.step_4_success_header}</h4>
          <p>{translation.brief_campaign.step_4_success_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Textarea
            type="text"
            name="success"
            label={translation.brief_campaign.step_4_success_label}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_campaign.step_4_budget_header}</h4>
          <p>{translation.brief_campaign.step_4_budget_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Textarea
            type="text"
            name="budget"
            label={translation.brief_campaign.step_4_budget_label}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_campaign.step_4_start_header}</h4>
          <p>{translation.brief_campaign.step_4_start_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Textarea
            type="text"
            name="start"
            label={translation.brief_campaign.step_4_start_label}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_campaign.step_4_graphics_header}</h4>
          <p>{translation.brief_campaign.step_4_graphics_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Textarea
            type="text"
            name="graphics"
            label={translation.brief_campaign.step_4_graphics_label}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>
            {translation.brief_campaign.step_4_selection_criterion_header}
          </h4>
          <p>{translation.brief_campaign.step_4_selection_criterion_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Textarea
            type="text"
            name="selection_criterion"
            label={translation.brief_campaign.step_4_selection_criterion_label}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_campaign.step_4_contact_type_header}</h4>
          <p>{translation.brief_campaign.step_4_contact_type_desc}</p>
        </div>
        <div className="col-md-5 offset-md-2">
          <Textarea
            type="text"
            name="contact_type"
            label={translation.brief_campaign.step_4_contact_type_label}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <div className="row brief_row">
        <div className="col-md-5">
          <h4>{translation.brief_campaign.step_4_get_from_desc}</h4>
        </div>
        <div className="col-md-5 offset-md-2">
          <Textarea
            type="text"
            name="get_from"
            label={translation.brief_campaign.step_4_get_from_label}
            register={register}
            errors={errors}
          />
        </div>
      </div>
      <Check
        register={register}
        name="term1"
        size="sm"
        validation={{ required: translation.brief_shop.input_required }}
        errors={errors}
        label={translation.brief_campaign.step_4_legal_first}
      />
      <Check
        register={register}
        name="term2"
        size="sm"
        label={translation.brief_campaign.step_4_legal_second}
      />
      <Check
        register={register}
        name="term3"
        size="sm"
        label={translation.legal_third}
      />
      <div className="divider" />
      <p>{translation.brief_campaign.step_4_legal_third}</p>
      <div className="divider" />
      <div className="btn-brief-group">
        <button
          type="button"
          className="btn_brief stepWrapperBtn"
          onClick={() => setStep(3)}
        >
          {translation.brief_campaign.step_1_prev_step}
        </button>
        <button
          type="submit"
          className="btn_brief"
          onClick={async () => {
            await triggerValidation([{ name: "get_from" }, { name: "term1" }]);
          }}
        >
          {translation.brief_campaign.step_4_send}
        </button>
      </div>
    </div>
  );
};

export default SubmitStep;
